import PickListSelection from "./PickListSelection.js";
import { gettext } from "../utils/i18n.js";
class LibrarySelection extends PickListSelection {
    constructor() {
        super(...arguments);
        this.selecting = false;
        this.cardClicked = (event) => {
            if (!this.root.hasAttribute("data-selecting") || !(event.target instanceof Element))
                return;
            if (event.target.closest("[data-selection-choice]"))
                return;
            const card = event.target.closest("[data-library-item]");
            const input = card?.querySelector("[data-selection-item]");
            if (!input)
                return;
            event.preventDefault();
            event.stopImmediatePropagation();
            input.click();
        };
        this.exitSelection = () => {
            this.selecting = false;
            this.clearSelection();
        };
        this.toggleSelection = () => {
            this.selecting = !this.root.hasAttribute("data-selecting");
            if (!this.selecting)
                this.clearSelection();
            this.update();
        };
    }
    init() {
        super.init();
        // Capture before navigation, lightbox and menu handlers inside the card.
        this.on(this.root, "click", this.cardClicked, { capture: true });
    }
    update() {
        super.update();
        const toggle = this.root.querySelector("[data-selection-toggle]");
        if (!toggle)
            return;
        const count = Number(this.root.querySelector("[data-selection-count]")?.textContent || 0);
        const active = this.selecting || count > 0;
        this.root.toggleAttribute("data-selecting", active);
        toggle.setAttribute("aria-pressed", String(active));
        const label = toggle.querySelector("span");
        const labelText = active
            ? gettext("Exit selection")
            : gettext("Select furniture");
        if (label && label.textContent !== labelText)
            label.textContent = labelText;
        for (const control of this.root.querySelectorAll("[data-selection-choice], [data-selection-options], [data-selection-actions]"))
            control.hidden = !active;
        for (const button of this.root.querySelectorAll("button[data-selection-link]"))
            button.disabled = count === 0;
        for (const card of this.root.querySelectorAll("[data-library-item]")) {
            card.toggleAttribute("data-selected", active && Boolean(card.querySelector("[data-selection-item]")?.checked));
            // In selection mode the native checkbox is the single keyboard/AT control.
            for (const link of card.querySelectorAll("a, button")) {
                if (active) {
                    // Keep originals in the DOM so back-navigation snapshots can restore them too.
                    if (!link.dataset.selectionNavigation)
                        link.dataset.selectionNavigation = JSON.stringify({ tabindex: link.getAttribute("tabindex"), ariaHidden: link.getAttribute("aria-hidden") });
                    link.setAttribute("tabindex", "-1");
                    link.setAttribute("aria-hidden", "true");
                }
                else {
                    if (link.dataset.selectionNavigation) {
                        const original = JSON.parse(link.dataset.selectionNavigation);
                        for (const [name, value] of [["tabindex", original.tabindex], ["aria-hidden", original.ariaHidden]]) {
                            if (value === null)
                                link.removeAttribute(name);
                            else
                                link.setAttribute(name, value);
                        }
                        delete link.dataset.selectionNavigation;
                    }
                }
            }
        }
    }
}
LibrarySelection.id = "LibrarySelection";
LibrarySelection.binds = {
    ...PickListSelection.binds,
    "[data-selection-toggle]": [["click", "toggleSelection"]],
    "[data-selection-exit]": [["click", "exitSelection"]],
};
export default LibrarySelection;
//# sourceMappingURL=LibrarySelection.js.map